import type { ReactNode } from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import ScienceOutlined from '@mui/icons-material/ScienceOutlined';
import { useAuth } from '@/auth';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { useTenant } from '@/tenant/useTenant';

export function AuthHeader({ title, subtitle }: { title: string; subtitle?: ReactNode }) {
  const { providerId } = useAuth();
  const { config } = useTenant();
  return (
    <Stack spacing={3} sx={{ mb: 3 }}>
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <BrandLogo />
        {providerId === 'mock' && (
          <Chip
            size="small"
            variant="soft"
            color="accent"
            icon={<ScienceOutlined />}
            label="Modo demo"
          />
        )}
      </Stack>
      {config.branding?.tagline && (
        <Typography variant="overline" color="primary" sx={{ lineHeight: 1.2 }}>
          {config.branding.tagline}
        </Typography>
      )}
      <Stack spacing={0.5}>
        <Typography variant="h4" component="h1">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
